import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const PricingPlansContainer = styled.div`
  max-width: 1310px !important;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 4.2rem 0;

  @media screen and (max-width: ${layout.sm}) {
    padding: 2rem 0;
  }
`

export const PricingPlansContent = styled.div`
  display: grid;
  box-sizing: border-box;
  padding: 0 1.5rem;
  justify-content: center;
  grid-row-gap: 1.8rem;

  .slick-slider {
    max-width: 100vw;
  }

  > a {
    max-width: 280px;
    width: 100%;
    margin: 0 auto;
    color: #141921;
  }

  @media screen and (max-width: ${layout.md}) {
    padding: 0;

    > h1, > p {
      padding: 0 1.5rem;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    grid-row-gap: 1.5rem;

    > div {
      padding-top: 0;
    }
  }
`
